import React from "react"
import { ThemeProvider } from "./theme"

export const WrapRootElement = ({ element }) => (<ThemeProvider>{element}</ThemeProvider>)

export default WrapRootElement